import { render, staticRenderFns } from "./TabGeneralDetail.vue?vue&type=template&id=366ae60c&"
import script from "./TabGeneralDetail.vue?vue&type=script&lang=js&"
export * from "./TabGeneralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports